// First-visit welcome popup — shown once per device after login (localStorage flag),
// its whole job is to point guests at the upload area, so the primary button jumps
// straight there. Limited (church-card) guests can't reach the upload area and get
// a plain greeting instead.
import React from 'react';
import Modal from './modal.jsx';
import { navigate } from '../router.jsx';
import { WELCOME, WELCOME_LIMITED } from '../text.js';
import { HeartIcon } from './icons.jsx';

export const WELCOME_KEY = 'hm_welcome_v1';

export default function Welcome({ limited, onClose }) {
	const close = () => {
		try {
			window.localStorage.setItem(WELCOME_KEY, '1');
		} catch {
			/* storage may be unavailable (private mode) — popup just shows again */
		}
		onClose();
	};

	const goUpload = () => {
		close();
		navigate('/galerie/gaestemedien');
	};

	const text = limited ? WELCOME_LIMITED : WELCOME;

	return (
		<Modal label={text.title} onClose={close}>
			<div className='welcome'>
				<span className='welcome__heart' aria-hidden='true'>
					<HeartIcon size={34} />
				</span>
				<h2 className='welcome__title'>{text.title}</h2>
				{text.body.map((p, i) => (
					<p className='welcome__text' key={i}>
						{p}
					</p>
				))}
				<div className='welcome__actions'>
					{limited ? (
						<button type='button' className='btn btn--primary' onClick={close}>
							{WELCOME_LIMITED.cta}
						</button>
					) : (
						<>
							<button type='button' className='btn btn--primary' onClick={goUpload}>
								{WELCOME.ctaUpload}
							</button>
							<button type='button' className='btn btn--ghost' onClick={close}>
								{WELCOME.ctaBrowse}
							</button>
						</>
					)}
				</div>
			</div>
		</Modal>
	);
}
